module.exports = __webpack_public_path__ + "media/images/icons/kulturniMapaW-398824b84296528d0983e1c5bff242fc.svg";